import { ChainTokenCheckResultFactory } from './chain-token-check-result.factory';
import { ChainTokenCheckDto } from '../dto';
import { ChainTokenCheck } from '../model';

export class ChainTokenCheckFactory {
  public static createFromDtos(dtos: ChainTokenCheckDto[]): ChainTokenCheck[] {
    if (!dtos) {
      return [];
    }

    return dtos.map(dto => this.createFromDto(dto));
  }

  public static createFromDto(dto: ChainTokenCheckDto): ChainTokenCheck {
    const check = new ChainTokenCheck();
    check.id = dto.id;
    check.creationDate = dto.creationDate;
    check.modificationDate = dto.modificationDate;
    check.results = dto.results.map(result =>
      ChainTokenCheckResultFactory.createFromDto(result),
    );
    return check;
  }
}
